import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ContractOutboundPhone } from '../../_types/contract-outbound-phone';
import { ContractOutboundPhonesService } from '../../_services/contracts-outbound-phones.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-outbound-phone-detail',
    templateUrl: './outbound-phone-detail.component.html',
    styleUrls: ['./outbound-phone-detail.component.scss'],
    standalone: false
})
export class ContractOutboundPhoneDetailComponent {
  public contractOutboundPhoneFormGroup!: RxFormGroup;

  public contractOutboundPhone: ContractOutboundPhone = new ContractOutboundPhone();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private contractOutboundPhonesService: ContractOutboundPhonesService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {
    this.contractOutboundPhoneFormGroup = this.formBuilder.formGroup<ContractOutboundPhone>(this.contractOutboundPhone) as RxFormGroup;
  }

  ngOnInit(): void {
    if (this.config.data.contractOutboundPhoneId) {
      this.loadContractOutboundPhone(this.config.data.contractOutboundPhoneId);
    } else {
      this.contractOutboundPhone.contractId = this.config.data.contractId;
    }
    this.allowWrite = this.loginService.hasPermission("COMPANIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("COMPANIES.DELETE");
  }

  async loadContractOutboundPhone(id: string) {
    this.contractOutboundPhone = await firstValueFrom(this.contractOutboundPhonesService.get(id));
    this.contractOutboundPhoneFormGroup.patchValue(this.contractOutboundPhone);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.contractOutboundPhoneFormGroup);
    if (valid) {
      this.contractOutboundPhone = Object.assign(this.contractOutboundPhone, this.contractOutboundPhoneFormGroup.value);

      await this.contractOutboundPhonesService.save(this.contractOutboundPhone).subscribe({
        next: (data) => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Teléfono guardado correctamente' });
          this.dynamicDialogRef.close();
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar el teléfono' });
        }
      });
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el teléfono?",
      header: "Eliminar teléfono",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractOutboundPhonesService.delete(this.contractOutboundPhone.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Teléfono eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  public phoneFilter: RegExp = /^[0-9 +]*$/;
}